<!--<b>INVESTERINGSAFTREK</b>-->
<!--<br/>-->
<!--Als een vennootschap in bedrijfsmiddelen investeert, kan de vennootschap onder voorwaarden in aanmerking komen voor investeringsaftrek.-->
<!--<br/><br/>-->
<!--Er zijn 3 verschillende investeringsregelingen:-->
<!--<ul>-->
<!--    <li>Kleinschaligheidsinvesteringsaftrek.</li>-->
<!--    <li>Energie-investeringsaftrek.</li>-->
<!--    <li>Milieu-investeringsaftrek.</li>-->
<!--</ul>-->
<!--<p>Voor de diverse investeringsregelingen gelden regels voor de bedrijfsmiddelen, het moment van investeren en het-->
<!--    jaar waarin de vennootschap de aftrek toepast.</p>-->

<!--<b>Investeren</b>-->

<!--<p>Voor de investeringsregelingen betekent investeren: het aangaan van een verplichting ter zake van de aanschaf-->
<!--    of verbetering van een bedrijfsmiddel, of het maken van voortbrengingskosten-->
<!--    voor een bedrijfsmiddel. Bij het aangaan van een verplichting is onder meer van belang dat de vennootschap te maken-->
<!--    krijgt met een-->
<!--    juridische betalingsverplichting. </p>-->

<!--<p>Enkele voorbeelden van ‘het aangaan van een verplichting’:</p>-->

<!--<ul>-->
<!--    <li>(schriftelijke) acceptatie van een geldige offerte</li>-->
<!--    <li>mondelinge aanvaarding, zonder voorbehoud, van een aanbod tot koop</li>-->
<!--    <li>schriftelijk sluiten van een koop- of verkoopovereenkomst</li>-->
<!--</ul>-->

<!--<b>In welk jaar verantwoordt de vennootschap de investeringsaftrek in de aangifte?</b>-->

<!--<p>Je vermeldt de investeringsaftrek in de aangifte over het jaar van investeren. Daarbij is ook van belang of de-->
<!--    vennootschap het-->
<!--    bedrijfsmiddel meteen in gebruik neemt of niet.</p>-->

<!--<b>Ingebruikname</b>-->

<!--<p>Je neemt de investeringsaftrek in aanmerking in het jaar waarin de vennootschap het bedrijfsmiddel in gebruik neemt.-->
<!--    Als de vennootschap een-->
<!--    bedrijfsmiddel nog niet in gebruik neemt, kan de vennootschap slechts investeringsaftrek claimen tot het bedrag dat-->
<!--    de vennootschap in het-->
<!--    boekjaar hebt betaald. Als er nog een restant aan investeringsaftrek is, kan de vennootschap dat in volgende jaren-->
<!--    in aftrek-->
<!--    brengen. Maar niet later dan het jaar van ingebruikname.</p>-->
<!--<div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <p><u>Voorbeeld</u></p>-->
<!--    <p>De vennootschap investeert in 2022 in een machine van € 100.000 en doet een aanbetaling van € 10.000. De machine-->
<!--        wordt midden-->
<!--        2023 geleverd, en de vennootschap betaalt in dat jaar € 16.000. Door omstandigheden neemt de vennootschap de-->
<!--        machine pas in 2024 in gebruik.-->
<!--        In de tussentijd betaalt de vennootschap niets.</p>-->
<!--    <p>Stel dat de vennootschap recht hebt op € 27.000 investeringsaftrek voor de machine, dan verloopt het recht op-->
<!--        investeringsaftrek als volgt:</p>-->
<!--    <p>In 2022 kan de vennootschap € 10.000 investeringsaftrek in aanmerking nemen, gelijk aan het bedrag van de eerste-->
<!--        betaling. Het-->
<!--        recht op de overige € 17.000 schuift door naar 2023. In 2023 neemt de vennootschap de machine nog niet in-->
<!--        gebruik, dus in dat-->
<!--        jaar is de aftrek maximaal € 16.000 (bedrag van de betaling). In 2024 neemt de vennootschap de machine in-->
<!--        gebruik. Dan kan de vennootschap-->
<!--        de rest van de investeringsaftrek claimen. Dat is € 27.000 (totale aftrek) - € 26.000 (de al in aanmerking-->
<!--        genomen aftrek) = € 1.000.</p>-->
<!--</div>-->

<!--<p><br>Als de vennootschap de investering niet binnen 3 jaar in gebruik neemt, is er sprake van een (fictieve)-->
<!--    desinvestering. Je moet-->
<!--    dan de desinvesteringsbijtelling toepassen. </p>-->

<!--<p>Ook als de vennootschap -bij een niet in gebruik genomen bedrijfsmiddel- niet binnen 12 maanden 25% van de-->
<!--    investering hebt-->
<!--    betaald, moet de vennootschap de desinvesteringsbijtelling toepassen.</p>-->

<!--<b>Verbetering van een bedrijfsmiddel</b>-->

<!--<p>Kosten van verbetering van een bestaand bedrijfsmiddel maakt de vennootschap om een bedrijfsmiddel geschikter te-->
<!--    maken voor het-->
<!--    gebruik binnen de onderneming. Kosten van verbetering komen in aanmerking voor investeringsaftrek, als het-->
<!--    bedrijfsmiddel zelf ook in aanmerking komt voor de aftrek. Onderhoudskosten zijn in het algemeen geen kosten van-->
<!--    verbetering.</p>-->

<!--<b>EIA en MIA/VAMIL: ‘nieuwe’ bedrijfsmiddelen</b>-->

<!--<p>Voor toepassing van de EIA en de MIA/VAMIL moet de vennootschap investeren in nieuwe bedrijfsmiddelen. ‘Nieuw’-->
<!--    betekent in dit-->
<!--    verband: niet eerder gebruikt. Tweedehands bedrijfsmiddelen komen dus niet in aanmerking. Voor de KIA hoeft een-->
<!--    bedrijfsmiddel niet nieuw te zijn.</p>-->

<!--<b>MIA/VAMIL: 'nieuwe' vervoermiddelen</b>-->

<!--<p>Voor de MIA en de VAMIL moet een voertuig ‘nieuw’ zijn. Hierbij gebruiken we de omschrijving die de omzetbelasting-->
<!--    gebruikt voor nieuwe vervoermiddelen. Een milieuvriendelijke auto is ‘nieuw’ als deze niet langer dan 6 maanden-->
<!--    geleden voor het-->
<!--    eerst in gebruik is genomen of niet meer dan 6.000 kilometer heeft gereden.</p>-->

<!--<b>Melden bij de Rijksdienst voor Ondernemend Nederland</b>-->

<!--<p>Als de vennootschap aanspraak wilt maken op EIA, MIA of VAMIL, moet dde vennootschap de investering hebben gemeld bij-->
<!--    RVO. </p>-->

<!--<b>Geen recht op investeringsaftrek</b>-->

<!--<b>Geen recht op investeringsaftrek</b>-->
<!--<p>Voor sommige investeringen is er geen recht op investeringsaftrek. Het gaat dan om:</p>-->

<!--<ul>-->
<!--    <li>Investeringen in bepaalde bedrijfsmiddelen, zoals woonhuizen, grond, dieren, vaartuigen voor representatieve-->
<!--        doeleinden, effecten, vorderingen, goodwill en publiekrechtelijke vergunningen. Op sommige-->
<!--        investeringen in woonhuizen kun je wel milieu-investeringsaftrek krijgen.-->
<!--    </li>-->
<!--    <li>Personenauto’s die niet bestemd zijn voor beroepsvervoer. Op sommige auto’s, zoals waterstofauto’s, kun je wel-->
<!--        milieu-investeringsaftrek krijgen.-->
<!--    </li>-->
<!--    <li>Bedrijfsmiddelen die voor ten minste 70% zijn bestemd voor verhuur (alleen uitgesloten voor de-->
<!--        kleinschaligheidsinvesteringsaftrek) of voor gebruik in het buitenland.-->
<!--    </li>-->
<!--    <li>Investeringen waarvoor de vennootschap verplichtingen aangaat tegenover personen die behoren tot het huishouden,-->
<!--        bloed- en-->
<!--        aanverwanten in de rechte lijn of personen die behoren tot hun huishouden.-->
<!--    </li>-->
<!--    <li>Transacties tussen gerechtigden van een nalatenschap. Bij deze transacties is ontheffing mogelijk.</li>-->
<!--</ul>-->

<!--<b>Minimum investeringsbedrag</b>-->

<!--<p>Bedrijfsmiddelen met een investeringsbedrag van minder dan € 450 komen niet in aanmerking voor de-->
<!--    kleinschaligheidsinvesteringsaftrek.</p>-->

<!--<p>Voor de milieu-investeringsaftrek en de energie-investeringsaftrek is het minimale investeringsbedrag €-->
<!--    2.500 per bedrijfsmiddel.</p>-->

<!--<p>Kan de vennnootschap de btw op de aanschaf terugkrijgen, dan neem je voor de investeringsaftrek het aanschafbedrag-->
<!--    exclusief-->
<!--    btw. Heeft de vebnootschap geen recht op btw-aftrek, bijvoorbeeld omdat de vennootschap alleen vrijgestelde-->
<!--    prestaties verricht? Dan ga je-->
<!--    uit van het investeringsbedrag inclusief btw.</p>-->

<!--<br/>-->
<!--<b>KLEINSCHALIGHEIDSAFTREK (KIA)</b>-->
<!--<p>Als de vennootschap in een boekjaar investeert in bedrijfsmiddelen, dan kan zij in aanmerking komen voor de-->
<!--    kleinschaligheidsinvesteringsaftrek (KIA). De bedrijfsmiddelen waarin de vennootschap investeert, moeten dan wel in-->
<!--    aanmerking komen voor investeringsaftrek.</p>-->

<!--<p>De KIA is een aftrekpost op de winst. Het bedrag dat je mag aftrekken, hangt af van het geïnvesteerde bedrag in het-->
<!--    boekjaar. Je vindt het bedrag van de KIA in de tabel.</p>-->

<!--<div *ngIf="this.year === 2024" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <b>Tabel kleinschaligheidsinvesteringsaftrek 2024</b>-->
<!--    <table>-->
<!--        <thead>-->
<!--        <tr>-->
<!--            <th class="col-1">Investering</th>-->
<!--            <th class="col-2">Kleinschaligheidsinvesteringsaftrek</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr>-->
<!--            <td class="col-1">niet meer dan €&nbsp;2.800</td>-->
<!--            <td class="col-2">0%</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">€&nbsp;2.801 t/m €&nbsp;69.765</td>-->
<!--            <td class="col-2">28% van het investeringsbedrag</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">€&nbsp;69.766 t/m €&nbsp;129.194</td>-->
<!--            <td class="col-2">€&nbsp;19.535</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">€&nbsp;129.195 t/m €&nbsp;387.580</td>-->
<!--            <td class="col-2">€&nbsp;19.535 verminderd met 7,56% van het deel van het investeringsbedrag boven de €&nbsp;129.195-->
<!--            </td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">meer dan €&nbsp;387.580</td>-->
<!--            <td class="col-2">0%</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--    </table>-->
<!--</div>-->
<!--<div *ngIf="this.year === 2023" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <b>Tabel kleinschaligheidsinvesteringsaftrek 2023</b>-->
<!--    <table>-->
<!--        <thead>-->
<!--        <tr>-->
<!--            <th class="col-1">Investering</th>-->
<!--            <th class="col-2">Kleinschaligheidsinvesteringsaftrek</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr>-->
<!--            <td class="col-1">niet meer dan €&nbsp;2.600</td>-->
<!--            <td class="col-2">0%</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">€&nbsp;2.601 t/m €&nbsp;63.716</td>-->
<!--            <td class="col-2">28% van het investeringsbedrag</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">€&nbsp;63.717 t/m €&nbsp;117.991</td>-->
<!--            <td class="col-2">€&nbsp;17.841</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">€&nbsp;117.992 t/m €&nbsp;353.973</td>-->
<!--            <td class="col-2">€&nbsp;17.841 verminderd met 7,56% van het deel van het investeringsbedrag boven de €&nbsp;117.991-->
<!--            </td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--            <td class="col-1">meer dan €&nbsp;353.973</td>-->
<!--            <td class="col-2">0%</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--    </table>-->
<!--</div>-->

<!--<br/>-->
<!--<br/>-->

<!--<b>ENERGIE-INVESTERINGSAFTREK (EIA)</b>-->
<!--<p>Het doel van de energie-investeringsaftrek (EIA) is het stimuleren van investeringen in energiebesparende-->
<!--    bedrijfsmiddelen of in duurzame energie. De regeling is bedoeld voor ondernemers die in Nederland inkomsten- of-->
<!--    vennootschapsbelasting betalen.</p>-->

<!--<b>Wat is de EIA?</b>-->

<!--<p>De EIA is een fiscale aftrekregeling. De regeling biedt direct financieel voordeel aan ondernemers die investeren in-->
<!--    energiebesparende bedrijfsmiddelen en duurzame energie. Naast de afschrijving mag je van deze investeringen een-->
<!--    extra-->
<!--    bedrag aftrekken van de winst. </p>-->

<!--<b>Voorwaarden</b>-->

<!--<p>Een vennootschap komt in aanmerking voor de EIA als de investering in een bedrijfsmiddel voldoet aan de volgende 4-->
<!--    voorwaarden:</p>-->

<!--<ul>-->
<!--    <li>Het bedrag aan energie-investeringen is minimaal €&nbsp;2.500 per bedrijfsmiddel.</li>-->

<!--    <li>Het bedrijfsmiddel is niet eerder gebruikt.</li>-->

<!--    <li>Het bedrijfsmiddel staat op de zogenoemde energielijst. Je kunt <a-->
<!--            href="https://www.rvo.nl/subsidies-financiering/publicaties-energie-investeringsaftrek-eia" target="_blank">de-->
<!--        energielijst-->
<!--        downloaden van de internetsite van RVO.nl</a>.-->
<!--    </li>-->

<!--    <li>De vennootschap kan voor hetzelfde bedrijfsmiddel geen energie-investeringsaftrek én milieu-investeringsaftrek-->
<!--        tegelijk-->
<!--        krijgen. Je kunt de EIA wel combineren met de kleinschaligheidsinvesteringsaftrek.-->
<!--    </li>-->
<!--</ul>-->

<!--<p>In de Energielijst staat welke bedrijfsmiddelen in ieder geval in aanmerking komen voor de EIA. Daarnaast komen in-->
<!--    aanmerking voor de EIA:</p>-->

<!--<ul>-->
<!--    <li>bedrijfsmiddelen die niet op de Energielijst staan, maar wel energie of fossiele brandstoffen besparen en een-->
<!--        algemene besparingsnorm halen-->
<!--    </li>-->

<!--    <li>de kosten van een energieadvies, onder bepaalde voorwaarden</li>-->
<!--</ul>-->

<!--<b>Hoe maak je gebruik van de EIA-regeling?</b>-->

<!--<ol>-->
<!--    <li>Binnen 3 maanden na de investering doe je een melding bij <a-->
<!--            href="https://www.rvo.nl/subsidies-financiering/eia/ondernemers" target=" _blank">RVO.nl</a>.-->
<!--    </li>-->

<!--    <li>Je ontvangt een ontvangstbevestiging die je moet bewaren bij de boekhouding.</li>-->

<!--    <li>Geef de energie-investeringsaftrek aan in de aangifte. Daarna beslist uiteindelijk de Belastingdienst over de-->
<!--        aangifte. Eventueel wordt die beslissing ondersteund door een advies van RVO.nl.-->
<!--    </li>-->
<!--</ol>-->

<!--<div *ngIf="this.year === 2024" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <b>Energie-investeringsaftrek 2024</b>-->
<!--    <div><p>De energie-investeringsaftrek (EIA) is 40% als de vennootschap in 2024 investeert in-->
<!--        nieuwe bedrijfsmiddelen die voorkomen op de Energielijst. Het minimale investeringsbedrag is €&nbsp;2.500 per-->
<!--        bedrijfsmiddel. Het totale maximumbedrag voor investeringen is € 136 miljoen.</p>-->
<!--    </div>-->
<!--</div>-->

<!--<div *ngIf="this.year === 2023" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <b>Energie-investeringsaftrek 2023</b>-->
<!--    <div><p>De energie-investeringsaftrek (EIA) is 45,5% als de vennootschap in 2023 investeert in-->
<!--        nieuwe bedrijfsmiddelen die voorkomen op de Energielijst. Het minimale investeringsbedrag is €&nbsp;2.500 per-->
<!--        bedrijfsmiddel. Het totale maximumbedrag voor investeringen is € 136 miljoen.</p>-->
<!--    </div>-->
<!--</div>-->
<!--<br/>-->
<!--<br/>-->
<!--<b>MILIEU-INVESTERINGSAFTREK (MIA)/WILLEKEURIGE AFSCHRIJVING MILIEU-INVESTERINGEN (VAMIL)</b>-->

<!--<p>De Milieu-investeringsaftrek (MIA) en de Willekeurige afschrijving milieu-investeringen (VAMIL) zijn fiscale-->
<!--    voordelen voor ondernemers die investeren in milieuvriendelijke bedrijfsmiddelen.</p>-->

<!--<b>MIA</b>-->
<!--<p>De milieu-investeringsaftrek biedt de vennootschap de mogelijkheid de fiscale winst te verlagen. De vennootschap ka-->
<!--    tot 45% van het-->
<!--    investeringsbedrag in mindering brengen op de winst. Het percentage van de aftrek is afhankelijk van de-->
<!--    milieu-effecten en de gangbaarheid van het bedrijfsmiddel.</p>-->

<!--<b>VAMIL</b>-->
<!--<p>Met de VAMIL kan de vennootschap een investering op een willekeurig moment afschrijven. De willekeurige afschrijving-->
<!--    is beperkt-->
<!--    tot 75%. Door sneller afschrijven vermindert je de fiscale winst en betaal je minder belasting in dat jaar. Dit-->
<!--    biedt een liquiditeitsvoordeel.</p>-->

<!--<b>Combinatie MIA en VAMIL</b>-->
<!--<p>De MIA en VAMIL zijn twee verschillende regelingen maar worden vaak gecombineerd. Beide regelingen maken gebruik van-->
<!--    een gezamenlijke lijst, de Milieulijst. Op deze lijst staan alle bedrijfsmiddelen die in aanmerking komen voor MIA-->
<!--    en/of VAMIL. Ieder jaar verschijnt een nieuwe Milieulijst. Je kunt de <a-->
<!--            href="https://www.rvo.nl/subsidies-financiering/mia-vamil/milieulijst" target="_blank">milieulijsten-->
<!--        downloaden van de-->
<!--        internetsite van RVO</a>.</p>-->

<!--<b>Voorwaarden MIA</b>-->
<!--<p>Iedere onderneming die in Nederland inkomsten- of vennootschapsbelasting betaalt, kan in principe gebruikmaken van de-->
<!--    MIA/VAMIL. Een vennootschap komt in aanmerking voor de MIA/VAMIL als de investering voldoet aan onder meer de-->
<!--    volgende-->
<!--    voorwaarden:</p>-->
<!--<ul>-->
<!--    <li>Het bedrijfsmiddel staat op de milieulijst.</li>-->
<!--    <li>Het bedrijfsmiddel is niet eerder gebruikt.</li>-->
<!--    <li>De investering moet betrekking hebben op aanschaf- en voortbrengingskosten van het bedrijfsmiddel.</li>-->
<!--    <li>Het bedrag aan milieu-investeringen moet minimaal €&nbsp;2.500 per bedrijfsmiddel zijn.</li>-->
<!--</ul>-->

<!--<b>Hoe maak je gebruik van de MIA-regeling?</b>-->
<!--<ol>-->
<!--    <li>Binnen 3 maanden na de investering doe je een melding bij RVO.</li>-->
<!--    <li>Je krijgt een ontvangstbevestiging van RVO die je moet bewaren bij de boekhouding.</li>-->
<!--    <li>Je verwerkt de MIA/VAMIL in de aangifte, op basis van het bericht dat je krijgt van RVO. Daarna beslist-->
<!--        uiteindelijk de Belastingdienst over de aangifte. Die beslissing wordt eventueel ondersteund door een advies van-->
<!--        RVO. Krijg je het bericht van RVO pas nadat je al aangifte hebt gedaan? Dan kun je een aangepaste aangifte-->
<!--        indienen.-->
<!--    </li>-->
<!--</ol>-->
<!--<p>Het aftrekpercentage wordt in de Milieulijst aangegeven met een letter voor de bedrijfsmiddelcode.</p>-->

<!--<div *ngIf="this.year === 2024" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <b>Milieu-investeringsaftrek 2024</b>-->
<!--    <div>-->
<!--        <p>In 2024 is de milieu-investeringsaftrek:</p>-->
<!--        <table>-->
<!--            <thead>-->
<!--            <tr>-->
<!--                <th class="col-1">Milieu-investering</th>-->
<!--                <th class="col-2">Milieu-investeringsaftrek</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr>-->
<!--                <th class="col-1">bedrijfsmiddelcode F en G</th>-->
<!--                <td class="col-2">45%</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <th class="col-1">bedrijfsmiddelcode A en D</th>-->
<!--                <td class="col-2">36%</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <th class="col-1">bedrijfsmiddelcode B en E</th>-->
<!--                <td class="col-2">27%</td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </table>-->
<!--    </div>-->
<!--</div>-->

<!--<div *ngIf="this.year === 2023" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <b>Milieu-investeringsaftrek 2023</b>-->
<!--    <div>-->
<!--        <p>In 2023 is de milieu-investeringsaftrek:</p>-->
<!--        <table>-->
<!--            <thead>-->
<!--            <tr>-->
<!--                <th class="col-1">Milieu-investering</th>-->
<!--                <th class="col-2">Milieu-investeringsaftrek</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr>-->
<!--                <td class="col-1">bedrijfsmiddelcode F en G</td>-->
<!--                <td class="col-2">45%</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <td class="col-1">bedrijfsmiddelcode A en D</td>-->
<!--                <td class="col-2">36%</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--                <td class="col-1">bedrijfsmiddelcode B en E</td>-->
<!--                <td class="col-2">27%</td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--        </table>-->
<!--    </div>-->
<!--</div>-->

<!--<br/><br/>-->

<!--<div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <u>Voorbeeld MIA</u>-->
<!--    <p>Stel: de fiscale winst is €&nbsp;75.000 en je betaalt 25% belasting over uw fiscale winst.-->
<!--        Je investeert voor €&nbsp;50.000 in een bedrijfsmiddel dat op de Milieulijst met code A is vermeld. De aftrek-->
<!--        voor code A is 36% van €&nbsp;50.000, dat is €&nbsp;18.000. De fiscale winst wordt nu € 57.000 (€&nbsp;75.000 - -->
<!--        €&nbsp;18.000).-->
<!--        Zonder MIA zou je €&nbsp;75.000 x 25% = €&nbsp;18.750 belasting moeten betalen. Door gebruik te maken van de MIA-->
<!--        betaal je maar € 57.000 x 25% = €&nbsp;14.250 belasting. Je voordeel is € 4.500.</p>-->
<!--</div>-->
<!--<br/><br/>-->
<!--<div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <u>Voorbeeld VAMIL</u>-->
<!--    <p>Je koopt voor €&nbsp;50.000 een milieuvriendelijk bedrijfsmiddel met een levensduur van 10&nbsp;jaar zonder-->
<!--        restwaarde. In het kader van de reguliere afschrijving kun je hiervoor jaarlijks (€&nbsp;50.000 - €&nbsp;0 : 10-->
<!--        =) €&nbsp;5.000 aftrekken van de fiscale winst. Je kiest ervoor om in het investeringsjaar 75% van het totale-->
<!--        aanschafbedrag van €&nbsp;50.000 ofwel €&nbsp;37.500,-->
<!--        in 1 keer af te trekken van de winst. Dat levert een liquiditeitsvoordeel op.</p>-->
<!--</div>-->


<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Investeringsaftrek
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als een vennootschap in bedrijfsmiddelen investeert, kan de vennootschap onder voorwaarden in aanmerking
                komen voor investeringsaftrek.
                <br/><br/>
                Er zijn 3 verschillende investeringsregelingen:
                <ul>
                    <li>Kleinschaligheidsinvesteringsaftrek.</li>
                    <li>Energie-investeringsaftrek.</li>
                    <li>Milieu-investeringsaftrek.</li>
                </ul>
                <p>Voor de diverse investeringsregelingen gelden regels voor de bedrijfsmiddelen, het moment van
                    investeren en het
                    jaar waarin de vennootschap de aftrek toepast.</p>

                <b>Investeren</b>

                <p>Voor de investeringsregelingen betekent investeren: het aangaan van een verplichting ter zake van de
                    aanschaf
                    of verbetering van een bedrijfsmiddel, of het maken van voortbrengingskosten
                    voor een bedrijfsmiddel. Bij het aangaan van een verplichting is onder meer van belang dat de
                    vennootschap te maken
                    krijgt met een
                    juridische betalingsverplichting. </p>

                <p>Enkele voorbeelden van ‘het aangaan van een verplichting’:</p>

                <ul>
                    <li>(schriftelijke) acceptatie van een geldige offerte</li>
                    <li>mondelinge aanvaarding, zonder voorbehoud, van een aanbod tot koop</li>
                    <li>schriftelijk sluiten van een koop- of verkoopovereenkomst</li>
                </ul>

                <b>In welk jaar verantwoordt de vennootschap de investeringsaftrek in de aangifte?</b>

                <p>Je vermeldt de investeringsaftrek in de aangifte over het jaar van investeren. Daarbij is ook van
                    belang of de
                    vennootschap het
                    bedrijfsmiddel meteen in gebruik neemt of niet.</p>

                <b>Ingebruikname</b>

                <p>Je neemt de investeringsaftrek in aanmerking in het jaar waarin de vennootschap het bedrijfsmiddel in
                    gebruik neemt.
                    Als de vennootschap een
                    bedrijfsmiddel nog niet in gebruik neemt, kan de vennootschap slechts investeringsaftrek claimen tot
                    het bedrag dat
                    de vennootschap in het
                    boekjaar hebt betaald. Als er nog een restant aan investeringsaftrek is, kan de vennootschap dat in
                    volgende jaren
                    in aftrek
                    brengen. Maar niet later dan het jaar van ingebruikname.</p>
                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    <p>De vennootschap investeert in 2022 in een machine van € 100.000 en doet een aanbetaling van €
                        10.000. De machine
                        wordt midden
                        2023 geleverd, en de vennootschap betaalt in dat jaar € 16.000. Door omstandigheden neemt de
                        vennootschap de
                        machine pas in 2024 in gebruik.
                        In de tussentijd betaalt de vennootschap niets.</p>
                    <p>Stel dat de vennootschap recht hebt op € 27.000 investeringsaftrek voor de machine, dan verloopt
                        het recht op
                        investeringsaftrek als volgt:</p>
                    <p>In 2022 kan de vennootschap € 10.000 investeringsaftrek in aanmerking nemen, gelijk aan het
                        bedrag van de eerste
                        betaling. Het
                        recht op de overige € 17.000 schuift door naar 2023. In 2023 neemt de vennootschap de machine
                        nog niet in
                        gebruik, dus in dat
                        jaar is de aftrek maximaal € 16.000 (bedrag van de betaling). In 2024 neemt de vennootschap de
                        machine in
                        gebruik. Dan kan de vennootschap
                        de rest van de investeringsaftrek claimen. Dat is € 27.000 (totale aftrek) - € 26.000 (de al in
                        aanmerking
                        genomen aftrek) = € 1.000.</p>
                </div>

                <p><br>Als de vennootschap de investering niet binnen 3 jaar in gebruik neemt, is er sprake van een
                    (fictieve)
                    desinvestering. Je moet
                    dan de desinvesteringsbijtelling toepassen. </p>

                <p>Ook als de vennootschap -bij een niet in gebruik genomen bedrijfsmiddel- niet binnen 12 maanden 25%
                    van de
                    investering hebt
                    betaald, moet de vennootschap de desinvesteringsbijtelling toepassen.</p>

                <b>Verbetering van een bedrijfsmiddel</b>

                <p>Kosten van verbetering van een bestaand bedrijfsmiddel maakt de vennootschap om een bedrijfsmiddel
                    geschikter te
                    maken voor het
                    gebruik binnen de onderneming. Kosten van verbetering komen in aanmerking voor investeringsaftrek,
                    als het
                    bedrijfsmiddel zelf ook in aanmerking komt voor de aftrek. Onderhoudskosten zijn in het algemeen
                    geen kosten van
                    verbetering.</p>

                <b>EIA en MIA/VAMIL: ‘nieuwe’ bedrijfsmiddelen</b>

                <p>Voor toepassing van de EIA en de MIA/VAMIL moet de vennootschap investeren in nieuwe
                    bedrijfsmiddelen. ‘Nieuw’
                    betekent in dit
                    verband: niet eerder gebruikt. Tweedehands bedrijfsmiddelen komen dus niet in aanmerking. Voor de
                    KIA hoeft een
                    bedrijfsmiddel niet nieuw te zijn.</p>

                <b>MIA/VAMIL: 'nieuwe' vervoermiddelen</b>

                <p>Voor de MIA en de VAMIL moet een voertuig ‘nieuw’ zijn. Hierbij gebruiken we de omschrijving die de
                    omzetbelasting
                    gebruikt voor nieuwe vervoermiddelen. Een milieuvriendelijke auto is ‘nieuw’ als deze niet langer
                    dan 6 maanden
                    geleden voor het
                    eerst in gebruik is genomen of niet meer dan 6.000 kilometer heeft gereden.</p>

                <b>Melden bij de Rijksdienst voor Ondernemend Nederland</b>

                <p>Als de vennootschap aanspraak wilt maken op EIA, MIA of VAMIL, moet dde vennootschap de investering
                    hebben gemeld bij
                    RVO. </p>

                <b>Geen recht op investeringsaftrek</b>

                <b>Geen recht op investeringsaftrek</b>
                <p>Voor sommige investeringen is er geen recht op investeringsaftrek. Het gaat dan om:</p>

                <ul>
                    <li>Investeringen in bepaalde bedrijfsmiddelen, zoals woonhuizen, grond, dieren, vaartuigen voor
                        representatieve
                        doeleinden, effecten, vorderingen, goodwill en publiekrechtelijke vergunningen. Op sommige
                        investeringen in woonhuizen kun je wel milieu-investeringsaftrek krijgen.
                    </li>
                    <li>Personenauto’s die niet bestemd zijn voor beroepsvervoer. Op sommige auto’s, zoals
                        waterstofauto’s, kun je wel
                        milieu-investeringsaftrek krijgen.
                    </li>
                    <li>Bedrijfsmiddelen die voor ten minste 70% zijn bestemd voor verhuur (alleen uitgesloten voor de
                        kleinschaligheidsinvesteringsaftrek) of voor gebruik in het buitenland.
                    </li>
                    <li>Investeringen waarvoor de vennootschap verplichtingen aangaat tegenover personen die behoren tot
                        het huishouden,
                        bloed- en
                        aanverwanten in de rechte lijn of personen die behoren tot hun huishouden.
                    </li>
                    <li>Transacties tussen gerechtigden van een nalatenschap. Bij deze transacties is ontheffing
                        mogelijk.
                    </li>
                </ul>

                <b>Minimum investeringsbedrag</b>

                <p>Bedrijfsmiddelen met een investeringsbedrag van minder dan € 450 komen niet in aanmerking voor de
                    kleinschaligheidsinvesteringsaftrek.</p>

                <p>Voor de milieu-investeringsaftrek en de energie-investeringsaftrek is het minimale investeringsbedrag
                    €
                    2.500 per bedrijfsmiddel.</p>

                <p>Kan de vennnootschap de btw op de aanschaf terugkrijgen, dan neem je voor de investeringsaftrek het
                    aanschafbedrag
                    exclusief
                    btw. Heeft de vebnootschap geen recht op btw-aftrek, bijvoorbeeld omdat de vennootschap alleen
                    vrijgestelde
                    prestaties verricht? Dan ga je
                    uit van het investeringsbedrag inclusief btw.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Kleinschaligheidsaftrek (KIA)
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Als de vennootschap in een boekjaar investeert in bedrijfsmiddelen, dan kan zij in aanmerking komen
                    voor de
                    kleinschaligheidsinvesteringsaftrek (KIA). De bedrijfsmiddelen waarin de vennootschap investeert,
                    moeten dan wel in
                    aanmerking komen voor investeringsaftrek.</p>

                <p>De KIA is een aftrekpost op de winst. Het bedrag dat je mag aftrekken, hangt af van het geïnvesteerde
                    bedrag in het
                    boekjaar. Je vindt het bedrag van de KIA in de tabel.</p>

                <div *ngIf="this.year === 2024"
                     style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <b>Tabel kleinschaligheidsinvesteringsaftrek 2024</b>
                    <table>
                        <thead>
                        <tr>
                            <th class="col-1">Investering</th>
                            <th class="col-2">Kleinschaligheidsinvesteringsaftrek</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="col-1">niet meer dan €&nbsp;2.800</td>
                            <td class="col-2">0%</td>
                        </tr>
                        <tr>
                            <td class="col-1">€&nbsp;2.801 t/m €&nbsp;69.765</td>
                            <td class="col-2">28% van het investeringsbedrag</td>
                        </tr>
                        <tr>
                            <td class="col-1">€&nbsp;69.766 t/m €&nbsp;129.194</td>
                            <td class="col-2">€&nbsp;19.535</td>
                        </tr>
                        <tr>
                            <td class="col-1">€&nbsp;129.195 t/m €&nbsp;387.580</td>
                            <td class="col-2">€&nbsp;19.535 verminderd met 7,56% van het deel van het investeringsbedrag
                                boven de €&nbsp;129.195
                            </td>
                        </tr>
                        <tr>
                            <td class="col-1">meer dan €&nbsp;387.580</td>
                            <td class="col-2">0%</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="this.year === 2023"
                     style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <b>Tabel kleinschaligheidsinvesteringsaftrek 2023</b>
                    <table>
                        <thead>
                        <tr>
                            <th class="col-1">Investering</th>
                            <th class="col-2">Kleinschaligheidsinvesteringsaftrek</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="col-1">niet meer dan €&nbsp;2.600</td>
                            <td class="col-2">0%</td>
                        </tr>
                        <tr>
                            <td class="col-1">€&nbsp;2.601 t/m €&nbsp;63.716</td>
                            <td class="col-2">28% van het investeringsbedrag</td>
                        </tr>
                        <tr>
                            <td class="col-1">€&nbsp;63.717 t/m €&nbsp;117.991</td>
                            <td class="col-2">€&nbsp;17.841</td>
                        </tr>
                        <tr>
                            <td class="col-1">€&nbsp;117.992 t/m €&nbsp;353.973</td>
                            <td class="col-2">€&nbsp;17.841 verminderd met 7,56% van het deel van het investeringsbedrag
                                boven de €&nbsp;117.991
                            </td>
                        </tr>
                        <tr>
                            <td class="col-1">meer dan €&nbsp;353.973</td>
                            <td class="col-2">0%</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Energie-investeringsaftrek (EIA)
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Het doel van de energie-investeringsaftrek (EIA) is het stimuleren van investeringen in
                    energiebesparende
                    bedrijfsmiddelen of in duurzame energie. De regeling is bedoeld voor ondernemers die in Nederland
                    inkomsten- of
                    vennootschapsbelasting betalen.</p>

                <b>Wat is de EIA?</b>

                <p>De EIA is een fiscale aftrekregeling. De regeling biedt direct financieel voordeel aan ondernemers
                    die investeren in
                    energiebesparende bedrijfsmiddelen en duurzame energie. Naast de afschrijving mag je van deze
                    investeringen een
                    extra
                    bedrag aftrekken van de winst. </p>

                <b>Voorwaarden</b>

                <p>Een vennootschap komt in aanmerking voor de EIA als de investering in een bedrijfsmiddel voldoet aan
                    de volgende 4
                    voorwaarden:</p>

                <ul>
                    <li>Het bedrag aan energie-investeringen is minimaal €&nbsp;2.500 per bedrijfsmiddel.</li>

                    <li>Het bedrijfsmiddel is niet eerder gebruikt.</li>

                    <li>Het bedrijfsmiddel staat op de zogenoemde energielijst. Je kunt <a
                            href="https://www.rvo.nl/subsidies-financiering/publicaties-energie-investeringsaftrek-eia"
                            target="_blank">de
                        energielijst
                        downloaden van de internetsite van RVO.nl</a>.
                    </li>

                    <li>De vennootschap kan voor hetzelfde bedrijfsmiddel geen energie-investeringsaftrek én
                        milieu-investeringsaftrek
                        tegelijk
                        krijgen. Je kunt de EIA wel combineren met de kleinschaligheidsinvesteringsaftrek.
                    </li>
                </ul>

                <p>In de Energielijst staat welke bedrijfsmiddelen in ieder geval in aanmerking komen voor de EIA.
                    Daarnaast komen in
                    aanmerking voor de EIA:</p>

                <ul>
                    <li>bedrijfsmiddelen die niet op de Energielijst staan, maar wel energie of fossiele brandstoffen
                        besparen en een
                        algemene besparingsnorm halen
                    </li>

                    <li>de kosten van een energieadvies, onder bepaalde voorwaarden</li>
                </ul>

                <b>Hoe maak je gebruik van de EIA-regeling?</b>

                <ol>
                    <li>Binnen 3 maanden na de investering doe je een melding bij <a
                            href="https://www.rvo.nl/subsidies-financiering/eia/ondernemers" target=" _blank">RVO.nl</a>.
                    </li>

                    <li>Je ontvangt een ontvangstbevestiging die je moet bewaren bij de boekhouding.</li>

                    <li>Geef de energie-investeringsaftrek aan in de aangifte. Daarna beslist uiteindelijk de
                        Belastingdienst over de
                        aangifte. Eventueel wordt die beslissing ondersteund door een advies van RVO.nl.
                    </li>
                </ol>

                <div *ngIf="this.year === 2024"
                     style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <b>Energie-investeringsaftrek 2024</b>
                    <div><p>De energie-investeringsaftrek (EIA) is 40% als de vennootschap in 2024 investeert in
                        nieuwe bedrijfsmiddelen die voorkomen op de Energielijst. Het minimale investeringsbedrag is €&nbsp;2.500
                        per
                        bedrijfsmiddel. Het totale maximumbedrag voor investeringen is € 136 miljoen.</p>
                    </div>
                </div>

                <div *ngIf="this.year === 2023"
                     style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <b>Energie-investeringsaftrek 2023</b>
                    <div><p>De energie-investeringsaftrek (EIA) is 45,5% als de vennootschap in 2023 investeert in
                        nieuwe bedrijfsmiddelen die voorkomen op de Energielijst. Het minimale investeringsbedrag is €&nbsp;2.500
                        per
                        bedrijfsmiddel. Het totale maximumbedrag voor investeringen is € 136 miljoen.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingT4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Milieu-investeringsaftrek (MIA) / Willekeurig afschrijving milieu-investeringen (VAMIL)
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="headingT4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>De Milieu-investeringsaftrek (MIA) en de Willekeurige afschrijving milieu-investeringen (VAMIL) zijn fiscale
                    voordelen voor ondernemers die investeren in milieuvriendelijke bedrijfsmiddelen.</p>

                <b>MIA</b>
                <p>De milieu-investeringsaftrek biedt de vennootschap de mogelijkheid de fiscale winst te verlagen. De vennootschap ka
                    tot 45% van het
                    investeringsbedrag in mindering brengen op de winst. Het percentage van de aftrek is afhankelijk van de
                    milieu-effecten en de gangbaarheid van het bedrijfsmiddel.</p>

                <b>VAMIL</b>
                <p>Met de VAMIL kan de vennootschap een investering op een willekeurig moment afschrijven. De willekeurige afschrijving
                    is beperkt
                    tot 75%. Door sneller afschrijven vermindert je de fiscale winst en betaal je minder belasting in dat jaar. Dit
                    biedt een liquiditeitsvoordeel.</p>

                <b>Combinatie MIA en VAMIL</b>
                <p>De MIA en VAMIL zijn twee verschillende regelingen maar worden vaak gecombineerd. Beide regelingen maken gebruik van
                    een gezamenlijke lijst, de Milieulijst. Op deze lijst staan alle bedrijfsmiddelen die in aanmerking komen voor MIA
                    en/of VAMIL. Ieder jaar verschijnt een nieuwe Milieulijst. Je kunt de <a
                            href="https://www.rvo.nl/subsidies-financiering/mia-vamil/milieulijst" target="_blank">milieulijsten
                        downloaden van de
                        internetsite van RVO</a>.</p>

                <b>Voorwaarden MIA</b>
                <p>Iedere onderneming die in Nederland inkomsten- of vennootschapsbelasting betaalt, kan in principe gebruikmaken van de
                    MIA/VAMIL. Een vennootschap komt in aanmerking voor de MIA/VAMIL als de investering voldoet aan onder meer de
                    volgende
                    voorwaarden:</p>
                <ul>
                    <li>Het bedrijfsmiddel staat op de milieulijst.</li>
                    <li>Het bedrijfsmiddel is niet eerder gebruikt.</li>
                    <li>De investering moet betrekking hebben op aanschaf- en voortbrengingskosten van het bedrijfsmiddel.</li>
                    <li>Het bedrag aan milieu-investeringen moet minimaal €&nbsp;2.500 per bedrijfsmiddel zijn.</li>
                </ul>

                <b>Hoe maak je gebruik van de MIA-regeling?</b>
                <ol>
                    <li>Binnen 3 maanden na de investering doe je een melding bij RVO.</li>
                    <li>Je krijgt een ontvangstbevestiging van RVO die je moet bewaren bij de boekhouding.</li>
                    <li>Je verwerkt de MIA/VAMIL in de aangifte, op basis van het bericht dat je krijgt van RVO. Daarna beslist
                        uiteindelijk de Belastingdienst over de aangifte. Die beslissing wordt eventueel ondersteund door een advies van
                        RVO. Krijg je het bericht van RVO pas nadat je al aangifte hebt gedaan? Dan kun je een aangepaste aangifte
                        indienen.
                    </li>
                </ol>
                <p>Het aftrekpercentage wordt in de Milieulijst aangegeven met een letter voor de bedrijfsmiddelcode.</p>

                <div *ngIf="this.year === 2024" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <b>Milieu-investeringsaftrek 2024</b>
                    <div>
                        <p>In 2024 is de milieu-investeringsaftrek:</p>
                        <table>
                            <thead>
                            <tr>
                                <th class="col-1">Milieu-investering</th>
                                <th class="col-2">Milieu-investeringsaftrek</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th class="col-1">bedrijfsmiddelcode F en G</th>
                                <td class="col-2">45%</td>
                            </tr>
                            <tr>
                                <th class="col-1">bedrijfsmiddelcode A en D</th>
                                <td class="col-2">36%</td>
                            </tr>
                            <tr>
                                <th class="col-1">bedrijfsmiddelcode B en E</th>
                                <td class="col-2">27%</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div *ngIf="this.year === 2023" style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <b>Milieu-investeringsaftrek 2023</b>
                    <div>
                        <p>In 2023 is de milieu-investeringsaftrek:</p>
                        <table>
                            <thead>
                            <tr>
                                <th class="col-1">Milieu-investering</th>
                                <th class="col-2">Milieu-investeringsaftrek</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="col-1">bedrijfsmiddelcode F en G</td>
                                <td class="col-2">45%</td>
                            </tr>
                            <tr>
                                <td class="col-1">bedrijfsmiddelcode A en D</td>
                                <td class="col-2">36%</td>
                            </tr>
                            <tr>
                                <td class="col-1">bedrijfsmiddelcode B en E</td>
                                <td class="col-2">27%</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




